import api from "src/apis/api"

export async function fetchQrCampaigns({ q = "", status = "" } = {}) {
  const params = new URLSearchParams()
  if (q) params.set("q", q)
  if (status) params.set("status", status)
  const { data } = await api.get(`/api/v1/qr_campaigns?${params}`)
  return data
}

export async function fetchQrCampaign(id) {
  const { data } = await api.get(`/api/v1/qr_campaigns/${id}`)
  return data.qr_campaign
}

export async function createQrCampaign(payload) {
  const { data } = await api.post("/api/v1/qr_campaigns", { qr_campaign: payload })
  return data.qr_campaign
}

export async function updateQrCampaign(id, payload) {
  const { data } = await api.patch(`/api/v1/qr_campaigns/${id}`, { qr_campaign: payload })
  return data.qr_campaign
}

export async function deleteQrCampaign(id) {
  const { data } = await api.delete(`/api/v1/qr_campaigns/${id}`)
  return data
}

// Availability + host preview for the subdomain field.
export async function checkSubdomain(subdomain, excludeId) {
  const params = new URLSearchParams()
  params.set("subdomain", subdomain)
  if (excludeId) params.set("exclude_id", excludeId)
  const { data } = await api.get(`/api/v1/qr_campaigns/check_subdomain?${params}`)
  return data
}

// URL for the QR code image (PNG) pointing at the campaign's micro-site.
export function qrCodeUrl(id, format = "png") {
  return `/api/v1/qr_campaigns/${id}/qr_code.${format}`
}
